import { makeStyles } from '@material-ui/core';
import { componentDimensions } from 'UI/constants/dimensions';

export const useDrawerStyles = makeStyles(theme => ({
  drawerLarge: {
    width: componentDimensions.drawer.large.width,
    overflowY: 'hidden',
    [theme.breakpoints.down(1024)]: {
      width: '80%'
    }
  },
  drawerContent: {
    padding: 0,
    flexGrow: 1,
    overflowY: 'auto'
  }
}));
